import {ChakraProvider, SystemContext} from "@chakra-ui/react";
import {ColorModeProvider, ColorModeProviderProps} from "./color-mode";

export function Provider({systemValue, ...props}: ColorModeProviderProps & {systemValue: SystemContext}) {
  return (
    <ChakraProvider value={systemValue}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
}
